import RescueRnRouter from "./routes/routes";
import { ToastContainer } from 'react-toastify';
function App() {
  return (
    <>
      <RescueRnRouter />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
